<template lang="pug">
	.icon-close(@click="$emit('click')")
</template>

<script>
export default {
  name : 'icon-close'
};
</script>

<style lang="scss" scoped>
.icon-close::before,
.icon-close::after {
	content: ' ';
    position: absolute;
    top: 50%;
    left: 50%;
    height: 18px;
    width: 4px;
    border-radius: 2px;
    background-color: currentColor;
}

.icon-close::before {
	transform: translate(-50%, -50%) rotate(45deg);
}

.icon-close::after {
	transform: translate(-50%, -50%) rotate(-45deg);
}
</style>
